// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"3fff058e","743":"c326f49b","752":"5b350ea3"}[chunkId] + ".js";
};